/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const notificationDataSchema = z.object({
	id: z.string(),
	type: z.string(),
	data: z.object({
		type: z.string(),
		message: z.string().nullable(),
		candidateId: z.string().nullable(),
		candidateName: z.string().nullable(),
		campaignId: z.string().nullable(),
		campaignName: z.string().nullable(),
		companySlug: z.string().nullable(),
		messageId: z.string().nullable(),
		emailId: z.string().nullable(),
		preview: z.string().nullable(),
		subject: z.string().nullable(),
		templateName: z.string().nullable(),
		status: z.string().nullable(),
		organisationId: z.string().nullable(),
		bookingId: z.string().nullable(),
		scheduledAt: z.string().nullable(),
		connectionId: z.string().nullable(),
		provider: z.string().nullable(),
		accountEmail: z.string().nullable(),
		reason: z.string().nullable(),
		authorName: z.string().nullable(),
		noteId: z.string().nullable(),
	}),
	readAt: z.iso.datetime().nullable(),
	createdAt: z.iso.datetime(),
})

export type NotificationDataSchema = z.infer<typeof notificationDataSchema>
